import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle, Phone, ArrowUp, CalendarCheck } from "lucide-react";
import { CONTACT } from "@/lib/site";
import { scrollTo } from "./Navbar";

export const FloatingActions = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      {/* Sticky consultation bar (mobile) */}
      <div className="lg:hidden fixed bottom-0 inset-x-0 z-40 p-3 bg-white/90 backdrop-blur-xl border-t border-black/5">
        <button data-testid="sticky-consult" onClick={() => scrollTo("contact")} className="w-full py-3.5 rounded-full bg-brand text-white font-semibold flex items-center justify-center gap-2">
          <CalendarCheck className="w-4 h-4" /> Book Free Consultation
        </button>
      </div>

      {/* Floating buttons */}
      <div className="fixed right-4 lg:right-6 bottom-20 lg:bottom-6 z-40 flex flex-col gap-3">
        <a data-testid="float-whatsapp" href={CONTACT.whatsapp} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp" className="grid place-items-center w-12 h-12 rounded-full bg-emerald text-white shadow-lg hover:scale-105 transition-transform">
          <MessageCircle className="w-5 h-5" />
        </a>
        <a data-testid="float-call" href={`tel:${CONTACT.phoneRaw}`} aria-label="Call" className="grid place-items-center w-12 h-12 rounded-full bg-brand text-white shadow-lg hover:scale-105 transition-transform">
          <Phone className="w-5 h-5" />
        </a>
        <AnimatePresence>
          {show && (
            <motion.button
              data-testid="float-back-to-top"
              initial={{ opacity: 0, scale: 0.6 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.6 }}
              onClick={() => (window.lenis ? window.lenis.scrollTo(0) : window.scrollTo({ top: 0, behavior: "smooth" }))}
              aria-label="Back to top"
              className="grid place-items-center w-12 h-12 rounded-full bg-navy text-white shadow-lg hover:scale-105 transition-transform"
            >
              <ArrowUp className="w-5 h-5" />
            </motion.button>
          )}
        </AnimatePresence>
      </div>
    </>
  );
};
